import { decodeToken } from "react-jwt";
import { removeCookie } from "./cookie";

/**
 * Admin tokens expire 24h after sign-in (SurgoAdminApi's createJwt) and there is
 * no refresh flow, so an expired token means the session is over.
 *
 * A token minted before expiries existed carries no `exp`. Those are treated as
 * still valid, because the API also still accepts them — reporting them as
 * expired would bounce everyone to sign-in and, if this ships before the API,
 * straight back again with another exp-less token.
 */
export const isSessionExpired = (token: string): boolean => {
  const decoded = decodeToken<{ exp?: number }>(token);
  if (!decoded?.exp) {
    return false;
  }

  return decoded.exp * 1000 <= Date.now();
};

/**
 * Drops the session and sends the user to sign-in.
 *
 * A full navigation rather than a router redirect: the axios clients that call
 * this live outside the React tree, and reloading is also what clears the decoded
 * user out of redux. Guarded because a screen fires several requests at once and
 * each 401 would otherwise start its own redirect.
 */
let ending = false;

export const endSession = (): void => {
  if (ending) {
    return;
  }
  ending = true;

  removeCookie();
  window.location.replace("/signin");
};
